import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { QuoteStep1Component } from './quote/quote-step1/quote-step1.component'
import { QuoteStep2Component } from './quote/quote-step2/quote-step2.component'
import { QuoteStep3Component } from './quote/quote-step3/quote-step3.component'
import { QuoteStep4Component } from './quote/quote-step4/quote-step4.component'
import { QuoteStep5Component } from './quote/quote-step5/quote-step5.component'
import { QuoteStep6Component } from './quote/quote-step6/quote-step6.component'
import { QuoteStep7Component } from './quote/quote-step7/quote-step7.component'
import { QuoteStep8Component } from './quote/quote-step8/quote-step8.component'
import { QuoteStep12Component } from './quote/quote-step12/quote-step12.component'
import { QuoteStep10Component } from './quote/quote-step10/quote-step10.component'
import { QuoteStep9Component } from './quote/quote-step9/quote-step9.component'

// import { QuoteLogIn } from './quote/quote-log-in/quote-log-in.component'
import { QuoteStep11Component } from './quote/quote-step11/quote-step11.component'
// import { QuoteContainerFooter } from './layouts/quote/quote-footer/quote-container-footer.component'

import { QuoteContainerHeader } from './layouts/quote/quote-container-header/quote-container-header.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
// import { QuoteStep1DesktopComponent } from './quote/quote-step1/quote-step1-desktop/quote-step1-desktop.component'
// import { QuoteStep1MobileComponent } from './quote/quote-step1/quote-step1-mobile/quote-step1-mobile.component'
// import { QuoteStep2DesktopComponent } from './quote/quote-step2/quote-step2-desktop/quote-step2-desktop.component'
// import { QuoteStep2MobileComponent } from './quote/quote-step2/quote-step2-mobile/quote-step2-mobile.component'
// import { QuoteStep3MobileComponent } from './quote/quote-step3/quote-step3-mobile/quote-step3-mobile.component'
// import { QuoteStep4DesktopComponent } from './quote/quote-step4/quote-step4-desktop/quote-step4-desktop.component'
// import { QuoteStep4MobileComponent } from './quote/quote-step4/quote-step4-mobile/quote-step4-mobile.component'
// import { QuoteStep5MobileComponent } from './quote/quote-step5/quote-step5-mobile/quote-step5-mobile.component'
// import { QuoteStep6MobileComponent } from './quote/quote-step6/quote-step6-mobile/quote-step6-mobile.component'
import { QuoteStep7DesktopComponent } from './quote/quote-step7/quote-step7-desktop/quote-step7-desktop.component'
// import { QuoteStep7MobileComponent } from './quote/quote-step7/quote-step7-mobile/quote-step7-mobile.component'
import { QuoteStep8DesktopComponent } from './quote/quote-step8/quote-step8-desktop/quote-step8-desktop.component'
// import { QuoteStep8MobileComponent } from './quote/quote-step8/quote-step8-mobile/quote-step8-mobile.component'
import { QuoteStep9DesktopComponent } from './quote/quote-step9/quote-step9-desktop/quote-step9-desktop.component'
// import { QuoteStep9MobileComponent } from './quote/quote-step9/quote-step9-mobile/quote-step9-mobile.component'
import { QuoteStep10DesktopComponent } from './quote/quote-step10/quote-step10-desktop/quote-step10-desktop.component'
// import { QuoteStep10MobileComponent } from './quote/quote-step10/quote-step10-mobile/quote-step10-mobile.component'
import { QuoteStep11DesktopComponent } from './quote/quote-step11/quote-step11-desktop/quote-step11-desktop.component'
// import { QuoteStep11MobileComponent } from './quote/quote-step11/quote-step11-mobile/quote-step11-mobile.component'
// import { QuoteStep12MobileComponent } from './quote/quote-step12/quote-step12-mobile/quote-step12-mobile.component'
import { QuoteStep12DesktopComponent } from './quote/quote-step12/quote-step12-desktop/quote-step12-desktop.component'
import { QuoteLoadingComponent } from './quote/quote-loading/quote-loading.component'
//import { QuoteStep13MobileComponent } from './quote/quote-step13/quote-step13-mobile/quote-step13-mobile.component'
// import { QuoteStep3DesktopComponent } from './quote/quote-step3/quote-step3-desktop/quote-step3-desktop.component'
import { QuoteStep5DesktopComponent } from './quote/quote-step5/quote-step5-desktop/quote-step5-desktop.component'
// import { QuoteStep6DesktopComponent } from './quote/quote-step6/quote-step6-desktop/quote-step6-desktop.component'
import { PerMemberSelectorComponent } from './quote/per-member-selector/per-member-selector.component';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AccordionModule } from 'primeng/accordion';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownComponent } from './inputs/select/select.component'
import { InputFieldComponent } from './inputs/field/input-field.component'
import { ErrorModalComponent } from './quote/quote-step3/error-modal.component'

@NgModule({
  declarations: [
    // QuoteContainerFooter,
    QuoteContainerHeader,
    QuoteStep1Component,
    QuoteStep2Component,
    QuoteStep3Component,
    QuoteStep4Component,
    QuoteStep5Component,
    QuoteStep6Component,
    QuoteStep7Component,
    QuoteStep8Component,
    QuoteStep9Component,
    QuoteStep10Component,
    QuoteStep11Component,
    QuoteStep12Component,
    QuoteLoadingComponent,
    // QuoteLogIn,
    // QuoteStep1DesktopComponent,
    // QuoteStep1MobileComponent,
    // QuoteStep2DesktopComponent,
    // QuoteStep2MobileComponent,
    // QuoteStep3DesktopComponent,
    // QuoteStep3MobileComponent,
    // QuoteStep4DesktopComponent,
    // QuoteStep4MobileComponent,
    QuoteStep5DesktopComponent,
    // QuoteStep5MobileComponent,
    // QuoteStep6DesktopComponent,
    // QuoteStep6MobileComponent,
    QuoteStep7DesktopComponent,
    // QuoteStep7MobileComponent,
    QuoteStep8DesktopComponent,
    // QuoteStep8MobileComponent,
    QuoteStep9DesktopComponent,
    // QuoteStep9MobileComponent,
    QuoteStep10DesktopComponent,
    // QuoteStep10MobileComponent,
    QuoteStep11DesktopComponent,
    // QuoteStep11MobileComponent,
    QuoteStep12DesktopComponent,
    // QuoteStep12MobileComponent,
    //QuoteStep13MobileComponent,
    PerMemberSelectorComponent,
    DropdownComponent,
    ErrorModalComponent,
  ],
  imports: [
    CommonModule, 
    RouterModule, 
    ReactiveFormsModule, 
    BrowserModule, 
    BrowserAnimationsModule, 
    FormsModule, 
    CalendarModule, 
    DropdownModule, 
    CheckboxModule, 
    DialogModule, 
    AccordionModule, 
    RadioButtonModule,
    InputSwitchModule,
    InputFieldComponent
  ],
  exports: [
    // QuoteContainerFooter,
    QuoteContainerHeader,
    QuoteStep1Component,
    QuoteStep2Component,
    QuoteStep3Component,
    QuoteStep4Component,
    QuoteStep5Component,
    QuoteStep6Component,
    QuoteStep7Component,
    QuoteStep8Component,
    QuoteStep9Component,
    QuoteStep10Component,
    QuoteStep11Component,
    QuoteStep12Component,
    QuoteLoadingComponent,
    // QuoteLogIn,
    // QuoteStep1DesktopComponent,
    // QuoteStep1MobileComponent,
    // QuoteStep2DesktopComponent,
    // QuoteStep2MobileComponent,
    // QuoteStep3DesktopComponent,
    // QuoteStep3MobileComponent,
    // QuoteStep4DesktopComponent,
    // QuoteStep4MobileComponent,
    QuoteStep5DesktopComponent,
    // QuoteStep5MobileComponent,
    // QuoteStep6DesktopComponent,
    // QuoteStep6MobileComponent,
    QuoteStep7DesktopComponent,
    // QuoteStep7MobileComponent,
    QuoteStep8DesktopComponent,
    // QuoteStep8MobileComponent,
    QuoteStep9DesktopComponent,
    // QuoteStep9MobileComponent,
    QuoteStep10DesktopComponent,
    // QuoteStep10MobileComponent,
    QuoteStep11DesktopComponent,
    // QuoteStep11MobileComponent,
    QuoteStep12DesktopComponent,
    // QuoteStep12MobileComponent,
    //QuoteStep13MobileComponent,
    PerMemberSelectorComponent,
    // DropdownComponent,
    ErrorModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
